var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"menu-profile-item",attrs:{"to":{ name: _vm.name }}},[_c('user-plus-icon',{staticClass:"header-menuitem-icon",attrs:{"size":"1x"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('dict.invitationCodes'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }